import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import kebabCase from 'lodash/kebabCase'
import Drawer from 'components/common/Drawer'
import { Field } from 'redux-form'
import model from '../../../viewModel'
import { getNumberOfSelectedServices } from './helpers'
import { LOOKING_FOR_TIRE_PRICES_CATEGORY } from '../../../constants'
import ServicesBlock from '../../../ServicesBlock'
import ServicesDrawerTitle from './ServicesDrawerTitle'

const ServicesDrawer = ({
  title,
  categoryServices,
  iconName,
  index,
  selectedServices,
  isPreExpand,
  inputColor = ''
}) =>
  <StyledDrawer
    withHeading
    preventHandleBlur
    expandedByDefault={ !!getNumberOfSelectedServices(selectedServices, categoryServices) || isPreExpand }
    drawerProps={{
      CustomDrawerTitle: ServicesDrawerTitle,
      title,
      expandedTitle: title,
      drawerIcon: iconName,
      altIcon: iconName,
      serviceDrawer: true,
      numberOfSelectedServices: getNumberOfSelectedServices(selectedServices, categoryServices),
      isPreExpand
    }}>
    <div
      role="region"
      id={ `${kebabCase(title)}-region-${index}` }
      aria-labelledby={ `${kebabCase(title)}-accordion-${index}` }>
      <Field
        { ...model.servicesSelector }
        component={ ServicesBlock }
        defaultData={ categoryServices }
        title={ title }
        inputColor={ inputColor }
        showLookingForTirePrices={ title === LOOKING_FOR_TIRE_PRICES_CATEGORY }
        servicesDrawer />
    </div>
  </StyledDrawer>

ServicesDrawer.propTypes = {
  categoryServices: PropTypes.arrayOf(PropTypes.shape()),
  iconName: PropTypes.string,
  index: PropTypes.number,
  inputColor: PropTypes.string,
  isPreExpand: PropTypes.bool,
  selectedServices: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string
}

export default ServicesDrawer

const StyledDrawer = styled(Drawer)`
  padding: 10px 10px 5px;
  margin-bottom: 5px;

  & [data-drawer-icon] {
    top: 11px;
  }
`
